var byteToHex = [];
for (var i$3 = 0; i$3 < 256; ++i$3) {
  byteToHex.push((i$3 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var e = "undefined", o$3 = "object", j$1 = "__", F$1 = "undefined" != typeof process ? process : {};
F$1.env && F$1.env.NODE_ENV || "";
var $$2 = "undefined" != typeof window;
null != F$1.versions && null != F$1.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
$$2 && "nodejs" === window.name || "undefined" != typeof navigator && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function M$2(n2, t2) {
  return t2.charAt(0)[n2]() + t2.slice(1);
}
var U$1 = M$2.bind(null, "toUpperCase"), H$2 = M$2.bind(null, "toLowerCase");
function J$1(n2) {
  return Y$1(n2) ? U$1("null") : "object" == typeof n2 ? yn$1(n2) : Object.prototype.toString.call(n2).slice(8, -1);
}
function R$1(n2, t2) {
  void 0 === t2 && (t2 = true);
  var e2 = J$1(n2);
  return t2 ? H$2(e2) : e2;
}
function V$1(n2, t2) {
  return typeof t2 === n2;
}
var W$1 = V$1.bind(null, "function"), q$1 = V$1.bind(null, "string");
V$1.bind(null, "undefined");
V$1.bind(null, "boolean");
V$1.bind(null, "symbol");
function Y$1(n2) {
  return null === n2;
}
function nn$1(n2) {
  return "number" === R$1(n2) && !isNaN(n2);
}
function yn$1(n2) {
  return W$1(n2.constructor) ? n2.constructor.name : null;
}
function hn$1(n2) {
  return n2 instanceof Error || q$1(n2.message) && n2.constructor && nn$1(n2.constructor.stackTraceLimit);
}
function On$1(n2, t2) {
  if ("object" != typeof t2 || Y$1(t2))
    return false;
  if (t2 instanceof n2)
    return true;
  var e2 = R$1(new n2(""));
  if (hn$1(t2))
    for (; t2; ) {
      if (R$1(t2) === e2)
        return true;
      t2 = Object.getPrototypeOf(t2);
    }
  return false;
}
On$1.bind(null, TypeError);
On$1.bind(null, SyntaxError);
function $n$1(n2, t2) {
  var e2 = n2 instanceof Element || n2 instanceof HTMLDocument;
  return e2 && t2 ? Tn$1(n2, t2) : e2;
}
function Tn$1(n2, t2) {
  return void 0 === t2 && (t2 = ""), n2 && n2.nodeName === t2.toUpperCase();
}
function _n$1(n2) {
  var t2 = [].slice.call(arguments, 1);
  return function() {
    return n2.apply(void 0, [].slice.call(arguments).concat(t2));
  };
}
_n$1($n$1, "form");
_n$1($n$1, "button");
_n$1($n$1, "input");
_n$1($n$1, "select");
var l$1 = "global", o$2 = j$1 + "global" + j$1, n$2 = typeof self === o$3 && self.self === self && self || typeof global === o$3 && global.global === global && global || void 0;
function a$2(t2) {
  return n$2[o$2][t2];
}
function f$2(t2, e2) {
  return n$2[o$2][t2] = e2;
}
function i$2(t2) {
  delete n$2[o$2][t2];
}
function u$1(t2, e2, r2) {
  var l2;
  try {
    if (b$1(t2)) {
      var o2 = window[t2];
      l2 = o2[e2].bind(o2);
    }
  } catch (t3) {
  }
  return l2 || r2;
}
n$2[o$2] || (n$2[o$2] = {});
var c$1 = {};
function b$1(t2) {
  if (typeof c$1[t2] !== e)
    return c$1[t2];
  try {
    var e$1 = window[t2];
    e$1.setItem(e, e), e$1.removeItem(e);
  } catch (e2) {
    return c$1[t2] = false;
  }
  return c$1[t2] = true;
}
var o$1 = "object", j = "__", F = "undefined" != typeof process ? process : {};
F.env && F.env.NODE_ENV || "";
var $$1 = "undefined" != typeof window;
null != F.versions && null != F.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
$$1 && "nodejs" === window.name || "undefined" != typeof navigator && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function M$1(n2, t2) {
  return t2.charAt(0)[n2]() + t2.slice(1);
}
var U = M$1.bind(null, "toUpperCase"), H$1 = M$1.bind(null, "toLowerCase");
function J(n2) {
  return Y(n2) ? U("null") : "object" == typeof n2 ? yn(n2) : Object.prototype.toString.call(n2).slice(8, -1);
}
function R(n2, t2) {
  void 0 === t2 && (t2 = true);
  var e2 = J(n2);
  return t2 ? H$1(e2) : e2;
}
function V(n2, t2) {
  return typeof t2 === n2;
}
var W = V.bind(null, "function"), q = V.bind(null, "string");
V.bind(null, "undefined");
V.bind(null, "boolean");
V.bind(null, "symbol");
function Y(n2) {
  return null === n2;
}
function nn(n2) {
  return "number" === R(n2) && !isNaN(n2);
}
function yn(n2) {
  return W(n2.constructor) ? n2.constructor.name : null;
}
function hn(n2) {
  return n2 instanceof Error || q(n2.message) && n2.constructor && nn(n2.constructor.stackTraceLimit);
}
function On(n2, t2) {
  if ("object" != typeof t2 || Y(t2))
    return false;
  if (t2 instanceof n2)
    return true;
  var e2 = R(new n2(""));
  if (hn(t2))
    for (; t2; ) {
      if (R(t2) === e2)
        return true;
      t2 = Object.getPrototypeOf(t2);
    }
  return false;
}
On.bind(null, TypeError);
On.bind(null, SyntaxError);
function $n(n2, t2) {
  var e2 = n2 instanceof Element || n2 instanceof HTMLDocument;
  return e2 && t2 ? Tn(n2, t2) : e2;
}
function Tn(n2, t2) {
  return void 0 === t2 && (t2 = ""), n2 && n2.nodeName === t2.toUpperCase();
}
function _n(n2) {
  var t2 = [].slice.call(arguments, 1);
  return function() {
    return n2.apply(void 0, [].slice.call(arguments).concat(t2));
  };
}
_n($n, "form");
_n($n, "button");
_n($n, "input");
_n($n, "select");
var o = j + "global" + j, n$1 = typeof self === o$1 && self.self === self && self || typeof global === o$1 && global.global === global && global || void 0;
function a$1(t2) {
  return n$1[o][t2];
}
function f$1(t2, e2) {
  return n$1[o][t2] = e2;
}
function i$1(t2) {
  delete n$1[o][t2];
}
n$1[o] || (n$1[o] = {});
var t = "cookie", i = a(), r$1 = d$1, c = d$1;
function u(o2) {
  return i ? d$1(o2, "", -1) : i$1(o2);
}
function a() {
  if (void 0 !== i)
    return i;
  var e2 = "cookiecookie";
  try {
    d$1(e2, e2), i = -1 !== document.cookie.indexOf(e2), u(e2);
  } catch (e3) {
    i = false;
  }
  return i;
}
function d$1(e2, t2, r2, c2, u2, a2) {
  if ("undefined" != typeof window) {
    var d2 = arguments.length > 1;
    return false === i && (d2 ? f$1(e2, t2) : a$1(e2)), d2 ? document.cookie = e2 + "=" + encodeURIComponent(t2) + (r2 ? "; expires=" + new Date(+/* @__PURE__ */ new Date() + 1e3 * r2).toUTCString() + (c2 ? "; path=" + c2 : "") + (u2 ? "; domain=" + u2 : "") + (a2 ? "; secure" : "") : "") : decodeURIComponent((("; " + document.cookie).split("; " + e2 + "=")[1] || "").split(";")[0]);
  }
}
var r = "localStorage", g = b$1.bind(null, "localStorage");
u$1("localStorage", "getItem", a$2);
u$1("localStorage", "setItem", f$2);
u$1("localStorage", "removeItem", i$2);
var n, f = "any", l = "*", h$1 = "undefined" != typeof process ? process : {};
(null == (n = h$1.env) ? void 0 : n.NODE_ENV) || "";
var z = "undefined" != typeof window;
null != h$1.versions && null != h$1.versions.node;
"undefined" != typeof Deno && void 0 !== Deno.core;
z && "nodejs" === window.name || "undefined" != typeof navigator && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function C$1(n2, e2) {
  return typeof e2 === n2;
}
C$1.bind(null, "function");
var L$1 = C$1.bind(null, "string"), $ = C$1.bind(null, "undefined");
C$1.bind(null, "boolean");
function H(n2) {
  return n2 && ("object" == typeof n2 || null !== n2);
}
function M(n2) {
  if (!H(n2))
    return false;
  for (var e2 = n2; null !== Object.getPrototypeOf(e2); )
    e2 = Object.getPrototypeOf(e2);
  return Object.getPrototypeOf(n2) === e2;
}
function y(t2) {
  var o2 = t2;
  try {
    if ("true" === (o2 = JSON.parse(t2)))
      return true;
    if ("false" === o2)
      return false;
    if (M(o2))
      return o2;
    parseFloat(o2) === o2 && (o2 = parseFloat(o2));
  } catch (t3) {
  }
  if (null !== o2 && "" !== o2)
    return o2;
}
var S = g(), k = a();
function I(o2, r2) {
  if (o2) {
    var e2 = L(r2), a2 = !A(e2), l2 = O(e2) ? y(localStorage.getItem(o2)) : void 0;
    if (a2 && !$(l2))
      return l2;
    var n2 = b(e2) ? y(r$1(o2)) : void 0;
    if (a2 && n2)
      return n2;
    var u2 = a$2(o2);
    return a2 ? u2 : { localStorage: l2, cookie: n2, global: u2 };
  }
}
function x(e2, a2, u2) {
  if (e2 && !$(a2)) {
    var c$12 = {}, f2 = L(u2), g2 = JSON.stringify(a2), m = !A(f2);
    return O(f2) && (c$12[r] = h(r, a2, y(localStorage.getItem(e2))), localStorage.setItem(e2, g2), m) ? c$12[r] : b(f2) && (c$12[t] = h(t, a2, y(r$1(e2))), c(e2, g2), m) ? c$12[t] : (c$12[l$1] = h(l$1, a2, a$2(e2)), f$2(e2, a2), m ? c$12[l$1] : c$12);
  }
}
function C(t$1, r$12) {
  if (t$1) {
    var a2 = L(r$12), i2 = I(t$1, l), n2 = {};
    return !$(i2.localStorage) && O(a2) && (localStorage.removeItem(t$1), n2[r] = i2.localStorage), !$(i2.cookie) && b(a2) && (u(t$1), n2[t] = i2.cookie), !$(i2.global) && d(a2, l$1) && (i$2(t$1), n2[l$1] = i2.global), n2;
  }
}
function L(t2) {
  return t2 ? L$1(t2) ? t2 : t2.storage : f;
}
function O(t2) {
  return S && d(t2, r);
}
function b(t$1) {
  return k && d(t$1, t);
}
function A(t2) {
  return t2 === l || "all" === t2;
}
function d(t2, o2) {
  return t2 === f || t2 === o2 || A(t2);
}
function h(t2, o2, r2) {
  return { location: t2, current: o2, previous: r2 };
}
var N = { setItem: x, getItem: I, removeItem: C };
const storage = N;
function decode(s) {
  try {
    return decodeURIComponent(s.replace(/\+/g, " "));
  } catch (e2) {
    return null;
  }
}
var inBrowser = typeof document !== "undefined";
function isExternalReferrer(ref) {
  if (!inBrowser)
    return false;
  var referrer = ref || document.referrer;
  if (referrer) {
    var port = window.document.location.port;
    var _ref = referrer.split("/")[2];
    if (port) {
      _ref = _ref.replace(":".concat(port), "");
    }
    return _ref !== window.location.hostname;
  }
  return false;
}
function getSearchString(url) {
  if (url) {
    var p = url.match(/\?(.*)/);
    return p && p[1] ? p[1].split("#")[0] : "";
  }
  return inBrowser && window.location.search.substring(1);
}
function paramsParse(url) {
  var searchString = getSearchString(url);
  return searchString ? getParamsAsObject(searchString) : {};
}
function getParamsAsObject(query) {
  var re = /([^&=]+)=?([^&]*)/g;
  var params = {};
  var e2;
  while (e2 = re.exec(query)) {
    var k2 = decode(e2[1]);
    var v = decode(e2[2]);
    if (k2.substring(k2.length - 2) === "[]") {
      k2 = k2.substring(0, k2.length - 2);
      (params[k2] || (params[k2] = [])).push(v);
    } else {
      var val = v === "" ? true : v;
      params[k2] = val;
    }
  }
  for (var prop in params) {
    var structure = prop.split("[");
    if (structure.length > 1) {
      var levels = [];
      structure.forEach(function(item, i2) {
        var key = item.replace(/[?[\]\\ ]/g, "");
        levels.push(key);
      });
      assign(params, levels, params[prop]);
      delete params[prop];
    }
  }
  return params;
}
function assign(obj, keyPath, value) {
  var lastKeyIndex = keyPath.length - 1;
  for (var i2 = 0; i2 < lastKeyIndex; ++i2) {
    var key = keyPath[i2];
    if (!(key in obj)) {
      obj[key] = {};
    }
    obj = obj[key];
  }
  obj[keyPath[lastKeyIndex]] = value;
}
function getDomainHost(url) {
  if (!inBrowser)
    return null;
  var a2 = document.createElement("a");
  a2.setAttribute("href", url);
  return a2.hostname;
}
function getDomainBase(url) {
  var host = getDomainHost(url) || "";
  return host.split(".").slice(-2).join(".");
}
function trimTld(baseDomain) {
  var arr = baseDomain.split(".");
  return arr.length > 1 ? arr.slice(0, -1).join(".") : baseDomain;
}
var googleKey = "google";
function parseReferrer(referrer, currentUrl) {
  if (!inBrowser)
    return false;
  var refData = {
    "source": "(direct)",
    "medium": "(none)",
    "campaign": "(not set)"
    // Add raw ref url if external
  };
  if (referrer && isExternalReferrer(referrer)) {
    refData.referrer = referrer;
  }
  var domainInfo = parseDomain(referrer);
  if (domainInfo && Object.keys(domainInfo).length) {
    refData = Object.assign({}, refData, domainInfo);
  }
  var params = paramsParse(currentUrl);
  var paramKeys = Object.keys(params);
  if (paramKeys.length) {
    var gaParams = paramKeys.reduce(function(acc, key) {
      if (key.match(/^utm_/)) {
        acc["".concat(key.replace(/^utm_/, ""))] = params[key];
      }
      if (key.match(/^(d|g)clid/)) {
        acc["source"] = googleKey;
        acc["medium"] = params.gclid ? "cpc" : "cpm";
        acc[key] = params[key];
      }
      return acc;
    }, {});
    refData = Object.assign({}, refData, gaParams);
    if (params.dclid || params.gclid) {
      refData["source"] = googleKey;
      refData["medium"] = params.gclid ? "cpc" : "cpm";
    }
  }
  return refData;
}
function parseDomain(referrer) {
  if (!referrer || !inBrowser)
    return false;
  var referringDomain = getDomainBase(referrer);
  var a2 = document.createElement("a");
  a2.href = referrer;
  if (a2.hostname.indexOf(googleKey) > -1) {
    referringDomain = googleKey;
  }
  if (searchEngines[referringDomain]) {
    var searchEngine = searchEngines[referringDomain];
    var queryParam = typeof searchEngine === "string" ? searchEngine : searchEngine.p;
    var termRegex = new RegExp(queryParam + "=.*?([^&#]*|$)", "gi");
    var term = a2.search.match(termRegex);
    return {
      source: searchEngine.n || trimTld(referringDomain),
      medium: "organic",
      term: (term ? term[0].split("=")[1] : "") || "(not provided)"
    };
  }
  var medium = !isExternalReferrer(referrer) ? "internal" : "referral";
  return {
    source: a2.hostname,
    medium
  };
}
var Q = "q";
var QUERY = "query";
var searchEngines = {
  "daum.net": Q,
  "eniro.se": "search_word",
  "naver.com": QUERY,
  "yahoo.com": "p",
  "msn.com": Q,
  "aol.com": Q,
  "lycos.com": Q,
  "ask.com": Q,
  "cnn.com": QUERY,
  "about.com": "terms",
  "baidu.com": "wd",
  "yandex.com": "text",
  "seznam.cz": Q,
  "search.com": Q,
  "yam.com": "k",
  "kvasir.no": Q,
  "terra.com": QUERY,
  "mynet.com": Q,
  "rambler.ru": "words",
  "google": Q,
  "bing.com": {
    "p": Q,
    "n": "live"
  }
};
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function formatPipeString(obj) {
  if (!obj || _typeof(obj) !== "object") {
    return null;
  }
  return Object.keys(obj).reduce(function(acc, curr, i2) {
    return "".concat(acc).concat(i2 ? "|" : "").concat(curr, "=").concat(obj[curr]);
  }, "");
}
function parsePipeString(cookie) {
  var keyMap = {
    "utmcsr": "source",
    "utmcmd": "medium",
    "utmccn": "campaign",
    "utmcct": "content",
    "utmctr": "term",
    "utmgclid": "gclid",
    // Google Click ID from autotagged PPC
    "utmdclid": "dclid"
    // Display Click Identifier.
  };
  var keyValues = cookie ? cookie.split("|") : [];
  return keyValues.reduce(function(acc, curr, i2) {
    var val = keyValues[i2].split("=");
    var key = val[0].split(".").pop();
    if (keyMap[key]) {
      acc["".concat(keyMap[key])] = decode(val[1]);
    } else if (typeof curr[key] === "undefined") {
      acc[key] = decode(val[1]);
    }
    return acc;
  }, {});
}
var events = {
  SET_ORIGINAL_SOURCE: "setOriginalSource"
};
var CONFIG = {
  storage: "localStorage",
  originalSourceKey: "__user_original_source",
  originalLandingPageKey: "__user_original_landing_page"
  /**
   * Track original source of visitors.
   * @param  {Object} [pluginConfig] - settings for referral source tracking
   * @param  {String} [pluginConfig.storage] - overide the location of storage. 'localStorage', 'cookie', or 'window'
   * @param  {String} [pluginConfig.originalSourceKey] - overide the storage key. Default '__user_original_source'
   * @param  {String} [pluginConfig.originalLandingPageKey] - overide the storage key. Default '__user_original_landing_page'
   * @return {Object} - plugin for `analytics` package
   */
};
function originalSourcePlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return {
    name: "original-source",
    EVENTS: events,
    config: _objectSpread({}, CONFIG, pluginConfig),
    // Run function on `analyticsInit` event
    bootstrap: function bootstrap(_ref) {
      var instance = _ref.instance, config = _ref.config;
      instance.dispatch({
        type: events.SET_ORIGINAL_SOURCE,
        originalSource: getOriginalSource(config),
        originalLandingPage: getOriginalLandingPage(config)
      });
    },
    reset: function reset(_ref2) {
      var instance = _ref2.instance;
      instance.storage.removeItem(CONFIG.originalSourceKey);
      instance.storage.removeItem(CONFIG.originalLandingPageKey);
    }
  };
}
function getOriginalSource() {
  var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var config = Object.assign({}, CONFIG, opts);
  var referrer = config.referrer, originalSourceKey = config.originalSourceKey;
  var originalSrc = storage.getItem(originalSourceKey, {
    storage: config.storage
  });
  if (originalSrc) {
    return parsePipeString(originalSrc);
  }
  var utmzCookie = r$1("__utmz");
  if (utmzCookie) {
    var parsedCookie = parsePipeString(utmzCookie);
    if (parsedCookie) {
      setOriginalSource(parsedCookie, config);
      return parsedCookie;
    }
  }
  var ref = inBrowser ? referrer || document.referrer : "";
  var refData = parseReferrer(ref);
  setOriginalSource(refData, config);
  return refData;
}
function setOriginalSource(data, config) {
  storage.setItem(config.originalSourceKey, formatPipeString(data), {
    storage: config.storage
  });
}
function getOriginalLandingPage() {
  var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var config = Object.assign({}, CONFIG, opts);
  var key = config.originalLandingPageKey;
  var storageConfig = {
    storage: config.storage
    // 1. try first source browser storage
  };
  var originalLandingPage = storage.getItem(key, storageConfig);
  if (originalLandingPage) {
    return originalLandingPage;
  }
  var url = inBrowser ? window.location.href : "";
  storage.setItem(key, url, storageConfig);
  return url;
}
export {
  getOriginalLandingPage as a,
  getOriginalSource as g,
  originalSourcePlugin as o,
  v4 as v
};
